module.exports = __webpack_public_path__ + "static/fabiola-and-co-339c0b3a36760d183d4c747d2e088d67.png";